import { isAndroid, isHarmony, isIos } from "./platform"

interface PlatformAdpter<R> {
    ios: () => R;
    android: () => R;
    harmony: () => R;
}

/**
 * 平台适配器
 */
export const platformAdpter = <T>(platforms: PlatformAdpter<T>) => {
    if (isIos) {
        return platforms.ios();
    }
    if (isAndroid) {
        return platforms.android();
    }
    if (isHarmony) {
        return platforms.harmony();
    }
    return platforms.android();
}